<app-dialog-header title="Availability Wizard" [showCloseButton]="true" (closeClicked)="onCloseClick()"></app-dialog-header>

<mat-dialog-content class="fullscreen-dialog">

  <ngx-ui-loader [loaderId]="'resourceLoad'"></ngx-ui-loader>
  <ngx-ui-loader [loaderId]="'bulkUpdate'"></ngx-ui-loader>
  <mat-horizontal-stepper #stepper [linear]="true">
    <mat-step [stepControl]="resourceFormGroup" class="step-container" label="Select Resources">
      <ng-template matStepLabel>
        {{ 'scheduler.availability-wizard.step1' | translate }}
        ({{ resourceGrid && resourceGrid.selectedRecords ? resourceGrid.selectedRecords.length : 0 }} selected)
      </ng-template>

      <div *matStepContent>
        <app-grid #resourceGrid [autoHeight]=true [cellEdit]="false" [columns]="resourceColumns" [filterBar]="true"
          [rowHeight]="50" [selectionMode]="selectionMode" [showRemoveRowInContextMenu]="false"
        [width]="'800px'"></app-grid>

      </div>

    </mat-step>
    <mat-step [stepControl]="typeFormGroup" label="Select Type">
      <ng-template matStepLabel>
        {{ 'scheduler.availability-wizard.step2' | translate }}
      </ng-template>
      <form [formGroup]="typeFormGroup">

        <div class="flex-row">
          <div class="circle-aligner">
            @if (isBlockType) {
              <div class="unavailability-circle"></div>
            }
            @if (!isBlockType) {
              <div class="availability-circle"></div>
            }
          </div>
          <mat-form-field appearance="fill" class="form-field full-width">
            <mat-label>Code (optional)</mat-label>
            <mat-select (selectionChange)="selectedCodeChange($event)" formControlName="availabilityCode"
              aria-label="Select availability code">
              <mat-option>None</mat-option>
              @for (code of availabilityCodes; track code) {
                <mat-option [value]="code">
                  <div class="flex-row">
                    <div
                      class="{{testIsBlockType(code.availabilityType)? 'unavailability-circle' : 'availability-circle'}}">
                    </div>
                    {{ code.description }}
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row">
          <mat-form-field appearance="fill" class="note-field full-width">
            <mat-label>Note (optional)</mat-label>
            <input formControlName="note" matInput placeholder="Enter note" aria-label="Note">
          </mat-form-field>
        </div>
        <div class="form-wrapper">

          <span>Cyclical Reservation</span>
          <mat-slider class="reservation-slider" [min]="0" [max]="100" [step]="1" [discrete]="true">
            <input matSliderThumb [value]="cyclicalPriorityReservationPercent"
              (valueChange)="cyclicalSliderChanged($event)" aria-label="Cyclical reservation percentage">
            </mat-slider>

            <span>Normal Reservation</span>
            <mat-slider class="reservation-slider" [min]="0" [max]="100" [step]="1" [discrete]="true">
              <input matSliderThumb [value]="normalPriorityReservationPercent" (valueChange)="normalSliderChanged($event)"
                aria-label="Normal reservation percentage">
              </mat-slider>

              <span>High Reservation</span>
              <mat-slider class="reservation-slider" [min]="0" [max]="100" [step]="1" [discrete]="true">
                <input matSliderThumb [value]="highPriorityReservationPercent" (valueChange)="highSliderChanged($event)"
                  aria-label="High reservation percentage">
                </mat-slider>

                <span>Emergency Reservation</span>
                <mat-slider class="reservation-slider" [min]="0" [max]="100" [step]="1" [discrete]="true">
                  <input matSliderThumb [value]="emergencyPriorityReservationPercent"
                    (valueChange)="emergencySliderChanged($event)" aria-label="Emergency reservation percentage">
                  </mat-slider>

                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="timingFormGroup" label="Select Timing">
              <ng-template matStepLabel>
                {{ 'scheduler.availability-wizard.step3' | translate }}
              </ng-template>
              <form [formGroup]="timingFormGroup">
                <div class="form-field flex-row space-around">
                  <mat-checkbox checked formControlName="monday">Monday</mat-checkbox>
                  <mat-checkbox checked formControlName="tuesday">Tuesday</mat-checkbox>
                  <mat-checkbox checked formControlName="wednesday">Wednesday</mat-checkbox>
                  <mat-checkbox checked formControlName="thursday">Thursday</mat-checkbox>
                  <mat-checkbox checked formControlName="friday">Friday</mat-checkbox>
                  <mat-checkbox formControlName="saturday">Saturday</mat-checkbox>
                  <mat-checkbox formControlName="sunday">Sunday</mat-checkbox>
                </div>

                <div class="flex-row">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Start Date</mat-label>
                    <input [matDatepicker]="startPicker" formControlName="startDate" matInput aria-label="Start date">
                    <mat-datepicker-toggle [for]="startPicker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>End Date</mat-label>
                    <input [matDatepicker]="endPicker" formControlName="endDate" matInput aria-label="End date">
                    <mat-datepicker-toggle [for]="endPicker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex-row">
                  <mat-form-field appearance="fill" class="form-field" style="width:113px">
                    <mat-label>Start</mat-label>
                    <input (change)="startTimeChanged($event)" formControlName="startTime" matInput type="time"
                      aria-label="Start time">
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="form-field" style="width:113px">
                      <mat-label>End</mat-label>
                      <input (change)="endTimeChanged($event)" formControlName="endTime" matInput type="time"
                        aria-label="End time">
                      </mat-form-field>
                    </div>
                  </form>
                </mat-step>

                <mat-step [stepControl]="conflictFormGroup" label="Preview">
                  <ng-template matStepLabel>
                    {{ 'scheduler.availability-wizard.step4' | translate }}
                  </ng-template>
                  <div *matStepContent>
                    @if (showError) {
                      <div>
                        <div class="error-panel"><i class="b-fa b-fa-exclamation-triangle pulse"></i> A problem preventing the Wizard
                        from completing it's work. This is still a new feature so there may be some bumps to work out, but just in
                        case it can be by changing something, the error message is displayed below.
                      </div>
                      <div>{{ errorMessage }}</div>
                    </div>
                  }
                  <app-grid #conflictGridDisplay [autoHeight]=true [cellEdit]="false" [columns]="conflictColumns"
                    [data]="conflictData" [filterBar]="false" [rowExpander]="rowConfig" [rowHeight]="50"
                  [showRemoveRowInContextMenu]="false" [width]="'800px'"></app-grid>

                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </mat-dialog-content>
          <mat-dialog-actions>
            <button (click)="stepperBack()" mat-button>{{ 'scheduler.general.back' | translate }}</button>
            <span class="flex-grow"></span>
            <button (click)="stepperNext()" color="primary" mat-flat-button>{{ 'scheduler.general.next' | translate }}</button>
          </mat-dialog-actions>
